import { render, staticRenderFns } from "./BillServices.vue?vue&type=template&id=3c61b5da&scoped=true&"
import script from "./BillServices.vue?vue&type=script&lang=js&"
export * from "./BillServices.vue?vue&type=script&lang=js&"
import style0 from "./BillServices.vue?vue&type=style&index=0&id=3c61b5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c61b5da",
  null
  
)

export default component.exports